import { Injectable } from '@angular/core';
import { EmailRequestDto, ResetPasswordEmailDto } from '@core/interfaces/email.interface';
import { VerifyReCaptchaDto } from '@core/interfaces/verify-recaptcha-dto.interface';
import { ApiServiceHolder } from '@core/utils/api-service-holder';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class EmailService {

  constructor(private _api: ApiService) { }

  showReCaptchaBadge() {
    const element = document.getElementsByClassName('grecaptcha-badge')[0] as HTMLElement;
    if (element) {
      element.style.visibility = 'visible';
    }
  }

  hideReCaptchaBadge() {
    const element = document.getElementsByClassName('grecaptcha-badge')[0] as HTMLElement;
    if (element) {
      element.style.visibility = 'hidden';
    }
  }

  sendContactFormEmail(emailRequest: EmailRequestDto) {
    return this._api.request(ApiServiceHolder.email.sendContactFormEmail(emailRequest));
  }

  sendResetPasswordEmail(emailRequest: ResetPasswordEmailDto) {
    return this._api.request(ApiServiceHolder.email.sendResetPasswordEmail(emailRequest));
  }

  verifyReCaptcha(verifyReCaptcha: VerifyReCaptchaDto) {
    return this._api.request(ApiServiceHolder.email.verifyReCaptcha(verifyReCaptcha));
  }

}
